import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SnackbarService } from '@core/services/snackbar.service';
import { CustomSnackbarType } from '@shared/component/custom-snackbar/custom-snackbar.model';
import { RegexPatterns } from '@shared/validators/regex-patterns.enum';
import { BehaviorSubject, EMPTY, Subject, tap } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Component({
	selector: 'sf-reset-password',
	templateUrl: './reset-password.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
	public resetPasswordForm: UntypedFormGroup;
	public isConfirmationVisible: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	public isLoginErrorSubject: Subject<boolean> = new Subject<boolean>();
	private readonly destroy$: Subject<void> = new Subject();

	constructor(
		private fb: UntypedFormBuilder,
		private authService: AuthService,
		private snackbarService: SnackbarService
	) {}

	ngOnInit(): void {
		this.resetPasswordForm = this.fb.group({
			email: ['', [Validators.required, Validators.pattern(RegexPatterns.EMAIL)]],
		});
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	public onSend(): void {
		this.authService
			.forgotPassword(this.resetPasswordForm.getRawValue())
			.pipe(
				catchError((error) => {
					if (error.status === 429) {
						this.snackbarService.openSnackbar({
							message: 'sf.module.auth.common.too_many_attempts',
							type: CustomSnackbarType.Error,
						});
						this.isLoginErrorSubject.next(true);
					}
					return EMPTY;
				}),
				tap(() => this.isConfirmationVisible.next(true)),
				takeUntil(this.destroy$)
			)
			.subscribe();
	}
}
